<template>
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.8089 7.21584L2.6724 0.520136C1.9926 0.238027 1.22459 0.362128 0.668142 0.843847C0.111696 1.32564 -0.121038 2.06799 0.0608369 2.78115L1.49713 8.41365H8.5294C8.853 8.41365 9.11538 8.676 9.11538 8.99963C9.11538 9.32322 8.85304 9.58561 8.5294 9.58561H1.49713L0.0608369 15.2181C-0.121038 15.9313 0.111657 16.6736 0.668142 17.1554C1.22572 17.6381 1.99381 17.7606 2.67244 17.4791L18.809 10.7834C19.5436 10.4786 20 9.79506 20 8.99963C20 8.2042 19.5436 7.52064 18.8089 7.21584Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'SendMessage',
};
</script>
